import { AddressType } from '@ukpostbox/client-data/lib/Types/AddressTypes';
import {
	Button,
	ButtonSize,
	FlexGap,
	FlexJustify,
	StackHorizontal,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useState } from 'react';
import ImportCsvModal from '../../../../Settings/Components/AddressImporter/Modals/ImportCsvModal';
import ImportVcfModal from '../../../../Settings/Components/AddressImporter/Modals/ImportVcfModal';
import { AddAddressTypeButtonsType } from '../Types/AddAddressTypes';
import { AddAddressModal } from './AddAddressModal';

function AddAddressTypeButtons(props: AddAddressTypeButtonsType) {
	const { t } = useTranslation();

	const [addAddressActive, setAddAddressActive] = useState<boolean>(false);
	const [importCsvOpen, setImportCsvOpen] = useState<boolean>(false);
	const [importVcfOpen, setImportVcfOpen] = useState<boolean>(false);

	const HandleAddressAdded = async (singleAddress: AddressType) => {
		setAddAddressActive(false);
		if (props.addressAddedCallback) {
			props.addressAddedCallback(singleAddress);
		}
	};

	const HandleCsvImported = async (bulkAddresses: Array<AddressType>) => {
		setAddAddressActive(false);
		if (props.csvImportedCallback) {
			props.csvImportedCallback(bulkAddresses);
		}
	};

	const HandleVcfImported = async (bulkAddresses: Array<AddressType>) => {
		setAddAddressActive(false);
		if (props.vcfImportedCallback) {
			props.vcfImportedCallback(bulkAddresses);
		}
	};

	return (
		<>
			<StackHorizontal gap={FlexGap.ExtraSmall} justify={FlexJustify.Between} fill>
				<Button
					title={t('address.actions.newAddress')}
					size={props.size || ButtonSize.Default}
					onClick={() => setAddAddressActive(true)}
					squared
					disabled={props.disabled}
				/>
				{!props.hideImportOptions && (
					<Button
						title={t('address.actions.importCsv')}
						size={props.size || ButtonSize.Default}
						onClick={() => setImportCsvOpen(true)}
						squared
						disabled={props.disabled}
					/>
				)}
				{!props.hideImportOptions && (
					<Button
						title={t('address.actions.importVcf')}
						size={props.size || ButtonSize.Default}
						onClick={() => setImportVcfOpen(true)}
						squared
						disabled={props.disabled}
					/>
				)}
			</StackHorizontal>

			<AddAddressModal
				isOpen={addAddressActive}
				closeCallback={() => setAddAddressActive(false)}
				actionedCallback={(address: AddressType) => HandleAddressAdded(address)}
			/>

			{!props.hideImportOptions && (
				<ImportCsvModal
					isOpen={importCsvOpen}
					closeCallback={() => setImportCsvOpen(false)}
					actionedCallback={(addresses: Array<AddressType>) => HandleCsvImported(addresses)}
				/>
			)}

			{!props.hideImportOptions && (
				<ImportVcfModal
					isOpen={importVcfOpen}
					closeCallback={() => setImportVcfOpen(false)}
					actionedCallback={(addresses: Array<AddressType>) => HandleVcfImported(addresses)}
				/>
			)}
		</>
	);
}

export { AddAddressTypeButtons };
